import React from 'react';
import { Button } from '../ui/button';
import { Download, Share, X, Smartphone } from 'lucide-react';
import { usePwaInstall } from '../../hooks/usePwaInstall';

// Bannière « Installer l'application » (mobile) : bouton natif Android/Chrome, consignes iOS Safari.
export const InstallBanner = ({ appName = 'OF Manager Formateur' }) => {
  const { visible, canPrompt, ios, install, dismiss } = usePwaInstall();
  if (!visible || (!canPrompt && !ios)) return null;

  return (
    <div className="relative overflow-hidden rounded-xl bg-slate-900 text-white p-4 pr-10 shadow-lg" data-testid="pwa-install-banner">
      <button type="button" onClick={dismiss} className="absolute top-2 right-2 p-1 rounded-md text-slate-400 hover:text-white hover:bg-white/10" aria-label="Fermer" data-testid="pwa-install-dismiss">
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-indigo-500 flex items-center justify-center shrink-0">
          <Smartphone className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">Installer l'application</p>
          <p className="text-xs text-slate-300 mt-0.5">Ajoutez <span className="font-medium text-white">{appName}</span> à votre écran d'accueil pour un accès rapide en plein écran.</p>
          {canPrompt ? (
            <Button type="button" size="sm" onClick={install} className="mt-3 h-8 bg-indigo-500 hover:bg-indigo-400 text-white" data-testid="pwa-install-button">
              <Download className="w-4 h-4 mr-1.5" /> Installer
            </Button>
          ) : (
            <ol className="mt-2 space-y-1 text-xs text-slate-200" data-testid="pwa-install-ios-steps">
              <li className="flex items-center gap-1.5"><span className="w-4 h-4 rounded-full bg-white/15 text-[10px] flex items-center justify-center shrink-0">1</span> Touchez <Share className="w-3.5 h-3.5 inline" /> <span className="font-medium">Partager</span> dans Safari</li>
              <li className="flex items-center gap-1.5"><span className="w-4 h-4 rounded-full bg-white/15 text-[10px] flex items-center justify-center shrink-0">2</span> Choisissez <span className="font-medium">« Sur l'écran d'accueil »</span> puis <span className="font-medium">Ajouter</span></li>
            </ol>
          )}
        </div>
      </div>
    </div>
  );
};
